// Initialize the .swiper_carousel Swiper with active slide transform effects
import Swiper from 'swiper';
import { Navigation, Pagination, A11y, Keyboard } from 'swiper/modules';
import { a11y } from './config/a11y';

export function initSwiperCarousel() {
    const el = document.querySelector('.swiper_carousel');
    if (!el) return null;

    const instance = new Swiper(el, {
        modules: [Navigation, Pagination, A11y, Keyboard],
        slidesPerView: 'auto',
        centeredSlides: true,
        spaceBetween: 0,
        loop: true,
        speed: 600,
        keyboard: {
            enabled: true,
            onlyInViewport: true
        },
        a11y,
        pagination: {
            el: el.querySelector('.swiper-pagination_image-slider') || '.swiper-pagination_image-slider',
            clickable: true
        },
        navigation: {
            nextEl: el.querySelector('.swiper-button-next') || '.swiper-button-next',
            prevEl: el.querySelector('.swiper-button-prev') || '.swiper-button-prev'
        },
        // Responsive breakpoints: Mobile wie collapse__gallery, Desktop wie bisher
        breakpoints: {
            // Mobile (< 768px): Normale Galerie-Ansicht
            0: {
                slidesPerView: 1,
                centeredSlides: false,
                spaceBetween: 0,
                loop: true
            },
            // Desktop (>= 768px): Carousel-Effekt
            768: {
                slidesPerView: 'auto',
                centeredSlides: true,
                spaceBetween: 0,
                loop: true
            }
        },
        on: {
            init: function () {
                updateSlideStyles(this);
            },
            slideChange: function () {
                updateSlideStyles(this);
            }
        }
    });

    function updateSlideStyles(swiper) {
        // Nur auf Desktop (>= 768px) Carousel-Effekte anwenden
        if (window.innerWidth >= 768) {
            swiper.slides.forEach((slide, index) => {
                if (index === swiper.activeIndex) {
                    slide.style.transform = 'scale(1.5)';
                    slide.style.opacity = '1';
                    slide.style.transition = 'transform 0.6s ease, opacity 0.6s ease';
                } else {
                    slide.style.transform = 'scale(1)';
                    slide.style.opacity = '0.5';
                    slide.style.transition = 'transform 0.6s ease, opacity 0.6s ease';
                }
            });
        } else {
            // Mobile: Keine Transformation, alle Slides normal
            swiper.slides.forEach((slide) => {
                slide.style.transform = 'scale(1)';
                slide.style.opacity = '1';
                slide.style.transition = 'none';
            });
        }
    }

    // Toggle functionality for caption overlay with ARIA support
    const toggleButtons = el.querySelectorAll('.collapse__gallery-toggle');
    toggleButtons.forEach((toggleBtn) => {
        toggleBtn.addEventListener('click', function () {
            const slide = this.closest('.swiper-slide');
            const isActive = toggleBtn.classList.contains('is-active');

            if (isActive) {
                // Close caption overlay
                toggleBtn.classList.remove('is-active');
                slide.classList.remove('overlay-visible');
                toggleBtn.setAttribute('aria-expanded', 'false');
            } else {
                // Open caption overlay
                toggleBtn.classList.add('is-active');
                slide.classList.add('overlay-visible');
                toggleBtn.setAttribute('aria-expanded', 'true');
            }
        });
    });

    return instance;
}
